export { default as ClipboardCheckOutlineIcon } from './ClipboardCheckOutlineIcon';
